import { render, staticRenderFns } from "./ContasList.vue?vue&type=template&id=28ed0160&scoped=true"
import script from "./ContasList.vue?vue&type=script&lang=js"
export * from "./ContasList.vue?vue&type=script&lang=js"
import style0 from "./ContasList.vue?vue&type=style&index=0&id=28ed0160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed0160",
  null
  
)

export default component.exports